import React, { Fragment } from "react";
import { Dropdown } from "semantic-ui-react";
import $ from "jquery";

const PartToDutyDropdown = (props) => {
    const { value, onSelectPart, t, partsList, i } = props;
    return (
        <Fragment>
            <Dropdown
                value={value}
                id={`partToDutyDropdown${i}`}
                className="mb-3"
                placeholder={t("selectOrType")}
                fluid
                selection
                options={partsList}
                onChange={(event, { value }) => {
                    onSelectPart(value);
                    $(`#partToDutyDropdown${i}`).removeClass("danger");
                }}
            />
        </Fragment>
    );
};

export default PartToDutyDropdown;
